<div [class.disabled-custom]="isLoading" (click)="openRestoreWorkoutDialog()">
    <div class="relative h-[200px]">
        <div class="border-2 rounded-2xl absolute top-0 left-0 w-full h-full hover:opacity-75 transition-all cursor-pointer">
            <img [src]="workout?.thumbnailUrl" class="absolute top-0 left-0 w-full h-full rounded-2xl object-cover" *ngIf="workout?.thumbnailUrl">
            <div class="absolute flex justify-center items-center w-full h-full bg-[#ffffff33] z-20">
                <mat-icon class="scale-[2]">refresh</mat-icon>

            </div>
            <div class="absolute left-0 bottom-0 w-full flex flex-col gap-3 p-[1rem] z-10 bg-white opacity-90">
                <p class="text-xl !m-0 truncate">{{workout.name}}</p>
                <div class="flex items-center gap-2 text-md text-gray-500">
                    <span>{{workout.playlists.length}} playlists</span>
                    <mat-icon class="scale-50">circle</mat-icon>
                    <span>
                {{ getExercisesCount() }} exercises
            </span>
                </div>
            </div>
        </div>

        <div class="absolute top-0 right-0 w-full h-full flex justify-center items-center " *ngIf="isLoading">
            <mat-spinner diameter="30"></mat-spinner>
        </div>
    </div>
</div>
